

const initailState = {
    arr:[],
    nextKey:''
}
const AccountsOutStandingReport=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_OUTSTANDING_DATA':
            return{ 
                arr: state.arr.concat(action.payload),
                nextKey:action.nextKey
            }
        default:
            return state;
    }
}

export default AccountsOutStandingReport
